module.exports = __webpack_public_path__ + "img/service1-07.36ba7561.png";